import { useState } from 'react';
import { formatDateMonthYear } from '../../../utils/Formatter';
import TextExcerptShowMore from './TextExcerptShowMore';
import TranslationToggle from './TranslationToggle';
import type { Review } from '../types';

import './ReviewDisplay.css';

interface ReviewDisplayProps {
  review: Review;
}

export default function ReviewDisplay({ review }: ReviewDisplayProps): JSX.Element {
  const [showOriginalComment, setShowOriginalComment] = useState(!review.comment.translated);

  function toggleShowOriginal(): void {
    setShowOriginalComment(!showOriginalComment);
  }

  return (
    <div className="review-display">
      <div className="review-display__username">{review.comment.userName}</div>
      <div className="review-display__date">{formatDateMonthYear(review.comment.commentDate)}</div>
      <div className="review-display__comment">
        <TextExcerptShowMore
          text={review.comment.comment}
          originalText={review.comment.originalComment}
          showOriginalComment={showOriginalComment}
          hasTranslation={review.comment.translated}
          maxLength={400}
        />
        {review.comment.translated && (
          <TranslationToggle
            showOriginalComment={showOriginalComment}
            toggleShowOriginal={(): void => toggleShowOriginal()}
          />
        )}
      </div>
    </div>
  );
}
